module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"swipe-tip":"swipe to explore"},"tr":{"swipe-tip":"kaydır ve keşfet"}}')
  delete Component.options._Ctor
}
